import { render } from "./ClientVentas.vue?vue&type=template&id=7769ceb5&scoped=true"
import script from "./ClientVentas.vue?vue&type=script&lang=js"
export * from "./ClientVentas.vue?vue&type=script&lang=js"

import "./ClientVentas.vue?vue&type=style&index=0&id=7769ceb5&scoped=true&lang=css"
import "./ClientVentas.vue?vue&type=style&index=1&id=7769ceb5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7769ceb5"]])

export default __exports__